/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.client.model

import systems.frictionless.impulse.rest.model.Email
import systems.frictionless.impulse.rest.model.Session

sealed class Authentication {
    object None : Authentication()

    data class Basic(val email: Email, val password: String) : Authentication()

    /**
     * Alternative to [Basic] for Javascript clients in a browser, to avoid the WWW-Authenticate header causing
     * a browser-owned popup from appearing if the authentication fails.
     */
    data class Form(val email: Email, val password: String) : Authentication()

    data class Bearer(val token: String) : Authentication()
}

fun Session.toAuthentication() = Authentication.Bearer(this.token)
